export default {
      id: "ic_star_favorited_dark_green-usage",
      viewBox: "2 2 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_star_favorited_dark_green-usage",
      toString: function () {
        return this.url;
      }
    }